import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import {
  Typography,
  TextField,
  MenuItem,
  Box,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Avatar,
  Hidden,
  TableContainer,
  Fab,
  Button,
  Grid,
  IconButton,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import EmailIcon from "@mui/icons-material/Email";
import DraftsIcon from "@mui/icons-material/Drafts";
import { useMessage } from "../../context/message-context";
import openFile from "../shared/functions/download";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import { FullPageSpinner } from "../lib";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useConfirm } from "../../context/confirm-context";
import EntgeltDetails from "./EntgeltDetails";
import HelpIcon from "@mui/icons-material/Help";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import AI_CHAT from "../AI_CHAT";
import { InfoOutlined } from "@mui/icons-material";
import DigitaleEntgeltabrechnung from "./DigitaleEntgeltabrechnung";
const styles = (theme) => ({
  root: {
    marginLeft: theme.spacing(9),
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  paper: {
    margin: theme.spacing(2),
  },
  form: {
    margin: theme.spacing(1),
    flex: 1,
  },
  avatar: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: theme.palette.secondary.main,
  },
  avatarClosed: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    backgroundColor: theme.palette.primary.main,
  },
});
function Payroll(props) {
  const { t } = useTranslation();
  const { client, accessToken, deviceId, classes } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState("POSTFACH");
  const [showModal, setShowModal] = useState(false);
  const [showEntgeltDetails, setShowEntgeltDetails] = useState("");

  const [ai_test, setAi_test] = useState(false);
  const [chatWindow, setChatWindow] = useState(false);
  const [mand, setMand] = useState(0);
  const [verknuepfung, setVerknuepfung] = useState([]);
  const navigate = useNavigate();
  const { hideMessage, showErrorMessage } = useMessage();
  const [versandArt, setVersandArt] = useState("");
  const confirm = useConfirm();

  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "LWEB01",
      statement: "LADE_PRIVATEN_BEREICH",
      deviceId: deviceId,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, documentsCb, errorCb);
    // eslint-disable-next-line
  }, []);
  const documentsCb = (response) => {
    if (response.status === 200) {
      setIsLoading(false);
      if (!response.data.versandInApp) {
        setVersandArt(response.data.versandArt);
        confirm({
          text: "Wenn Sie zustimmen, erhalten Sie Ihre Entgeltdokumente in Zukunft nur noch digital in der App und auf keinem anderen Weg mehr. Wollen Sie fortfahren?",
          title: "Entgeltunterlagen per App",
          buttons: "YESNO",
        })
          .then((antwort) => {
            console.log(antwort);
            setIsLoading(true);
            const payload = {
              mandant: client,
              program: "LWEB01",
              statement: "VERSAND_APP",
              deviceId: deviceId,
            };
            const headers = {
              Authorization: "Bearer " + accessToken,
            };
            apiRequest("POST", "daten", payload, headers, documentsCb, errorCb);
          })
          .catch((antwort) => {
            console.log(antwort);
            navigate(-1);
          });
      } else {
        if (response.data.verk) {
          setVerknuepfung(response.data.verk);
        }
        localStorage.setItem(LOCAL_STORAGE_KEY.private, "true");
      }
      if (response.data.inaktivMessage === "J") {
        confirm({
          text: "Sie haben noch Zugriff auf Ihre Entgeltabrechnungen bis: " + response.data.inaktivDatum + " ",
          title: "Hinweis: Zugang inaktiv!",
          buttons: "OK",
        })
          .then((antwort) => {})
          .catch((antwort) => {});
      }

      if (response.data.AI_TEST === "1") {
        setAi_test(true);
      }
      hideMessage();
    } else {
      if (response) {
        if (response.data.message === "Admincode bestaetigen") {
          navigate("/verify-admincode");
        } else {
          showErrorMessage(response.data.message);
        }
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Inhalt konnte nicht geladen werden. Bitte versuchen Sie es erneut."));
    navigate(-1);
  };
  const open = (key, name, count) => {
    setShowModal(true);
    downloadFile(key, name);
    if (type === "POSTFACH") {
      const verk = verknuepfung;
      verk[mand].documents.mailbox[count].style = "";
      setVerknuepfung(verk);
    }
  };
  const ladeMandanten = useMemo(() =>
    verknuepfung.map((element, count) => {
      return (
        <MenuItem value={count}>
          <Typography>{element.mdname}</Typography>
        </MenuItem>
      );
    })
  );

  const closeModal = () => {
    setShowModal(false);
  };
  const downloadFile = (key, name) => {
    let verknuepfterMand = "";
    verknuepfterMand = verknuepfung[mand].mdver;
    const payload = {
      mandant: client,
      program: "LWEB01",
      statement: "DOKUMENT_LADEN",
      file: key,
      type: type,
      verk: verknuepfterMand,
      deviceId: deviceId,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        if (response.status !== 200) {
          console.log(response.status);
          closeModal();
          const jsonResponse = JSON.parse(response.text());
          showErrorMessage(jsonResponse.message);
          return;
        }
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(name, contentFile, mimeType);
        closeModal();
      })
      .catch(async function (error) {
        console.log(await error.response.data.text());

        closeModal();
        if (error.response) {
          const jsonResponse = JSON.parse(await error.response.data.text());
          showErrorMessage(jsonResponse.message);
        } else {
          showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
        }
      });
  };
  const handleTypeChange = (event) => {
    setType(event.target.value);
  };
  const handleMandChange = (event) => {
    setMand(event.target.value);
    console.log("Mandant" + event.target.value);
  };
  const displayValues = () => {
    if (verknuepfung.length === 0) {
      return (
        <TableBody>
          <TableRow key="none">
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableBody>
      );
    }
    if (type === "DIGITALE_ENTGELTABRECHNUNG") {
      return    <DigitaleEntgeltabrechnung accessToken={accessToken} monate={verknuepfung[mand]?.documents?.digiEntgelt} client={client}/>;
    }
    if (type === "POSTFACH" && verknuepfung[mand].documents.mailbox) {
      const displayMailbox = verknuepfung[mand].documents.mailbox.map((dataObject, count) => {
        const style = dataObject.style;
        if (dataObject.type === "header") {
          return (
            <Hidden mdDown>
              <TableHead>
                <TableRow key={dataObject.key}>
                  <TableCell colSpan={2}>{dataObject.text}</TableCell>
                </TableRow>
              </TableHead>
            </Hidden>
          );
        }
        return (
          <TableBody>
            <TableRow style={{ cursor: "pointer" }} hover key={dataObject.key} onClick={() => open(dataObject.key, dataObject.name, count)}>
              <TableCell>
                <Avatar className={style === "primary" ? classes.avatarClosed : classes.avatar}>{style === "primary" ? <EmailIcon /> : <DraftsIcon />}</Avatar>
              </TableCell>
              <TableCell>{dataObject.text}</TableCell>
            </TableRow>
          </TableBody>
        );
      });
      return displayMailbox;
    } else if (type === "ENTGELT" && verknuepfung[mand].documents.payroll) {
      const displayEntgelt = verknuepfung[mand].documents.payroll.map((dataObject, count) => {
        return (
          <TableBody>
            <TableRow
              style={{ cursor: "pointer" }}
              hover
              key={dataObject.key}
              className={dataObject.style}
              onClick={() => open(dataObject.key, dataObject.name)}
            >
              <TableCell>
                {dataObject.text}
                {/* {dataObject.key!=="PAYROLL_DOC" && !dataObject.key.includes("ALLE")&&
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowEntgeltDetails(dataObject.key)
                  }}
                >
                  <InfoOutlined />
                </IconButton>
                   } */}
              </TableCell>
            </TableRow>
          </TableBody>
        );
      });
      return displayEntgelt;
    } else if (type === "LOHNSTEUER" && verknuepfung[mand].documents.tax) {
      const displayLst = verknuepfung[mand].documents.tax.map((dataObject, count) => {
        return (
          <TableBody>
            <TableRow
              style={{ cursor: "pointer" }}
              hover
              key={dataObject.key}
              className={dataObject.style}
              onClick={() => open(dataObject.key, dataObject.name)}
            >
              <TableCell>{dataObject.text}</TableCell>
            </TableRow>
          </TableBody>
        );
      });
      return displayLst;
    } else if (type === "SOZIALVERS" && verknuepfung[mand].documents.deuev) {
      const displayInsurance = verknuepfung[mand].documents.deuev.map((dataObject, count) => {
        return (
          <TableBody>
            <TableRow
              style={{ cursor: "pointer" }}
              hover
              key={dataObject.key}
              className={dataObject.style}
              onClick={() => open(dataObject.key, dataObject.name)}
            >
              <TableCell>{dataObject.text}</TableCell>
            </TableRow>
          </TableBody>
        );
      });
      return displayInsurance;
    } else if (type === "SPESEN" && verknuepfung[mand].documents.spesenJahr) {
      const displaySpesen = verknuepfung[mand].documents.spesenJahr.map((dataObject, countJahr) => {
        const Jahr = verknuepfung[mand].documents.spesenJahr[countJahr].text;
        return verknuepfung[mand].documents.spesen[countJahr].monate.map((dataObject, count) => {
          return (
            <TableRow
              style={{ cursor: "pointer" }}
              hover
              key={dataObject.key}
              className={dataObject.style}
              onClick={() => open(dataObject.key, dataObject.name, count)}
            >
              <TableCell>
                {dataObject.text} {Jahr}
              </TableCell>
            </TableRow>
          );
        });
      });
      return displaySpesen;
    }
  };
  if (isLoading) {
    return <LoadingComponent />;
  }
  return (
    <Page>
      <Layout>
        {verknuepfung.length > 1 && (
          <Box p={1}>
            <TextField
              id="folder"
              label={t("verknüpfte Firmen")}
              select
              fullWidth
              value={mand}
              onChange={(e) => {
                handleMandChange(e);
              }}
              variant="outlined"
            >
              {ladeMandanten}
            </TextField>
          </Box>
        )}
        <Box p={1}>
          <TextField
            id="type"
            label={t("Ordnerauswahl")}
            select
            fullWidth
            value={type}
            onChange={(e) => {
              handleTypeChange(e);
            }}
            variant="outlined"
          >
            <MenuItem key="POSTFACH" value="POSTFACH">
              {t("Postfach")}
            </MenuItem>
            <MenuItem key="ENTGELT" value="ENTGELT">
              {t("Entgeltbescheinigung")}
            </MenuItem>
            <MenuItem key="LOHNSTEUER" value="LOHNSTEUER">
              {t("Lohnsteuerbescheinigung")}
            </MenuItem>
            <MenuItem key="SOZIALVERS" value="SOZIALVERS">
              {t("Sozialversicherungsbescheinigung (DEUEV)")}
            </MenuItem>
            {verknuepfung[mand]?.documents?.digiEntgelt?.length > 0 && (
              <MenuItem key="DIGITALE_ENTGELTABRECHNUNG" value="DIGITALE_ENTGELTABRECHNUNG">
                {t("Digitale Entgeltabrechnung")}
              </MenuItem>
            )}
            {verknuepfung[mand]?.documents?.spesen && (
              <MenuItem key="SPESEN" value="SPESEN">
                {t("Spesenabrechnung")}
              </MenuItem>
            )}
          </TextField>
        </Box>

        {/* {ai_test && (
          <Fab color="primary" aria-label="add" style={{ position: "fixed", bottom: 20, right: 20 }} onClick={() => setChatWindow(true)}>
            <HelpIcon />
          </Fab>
        )} */}
        <TableContainer>
          <Table>{displayValues()}</Table>
        </TableContainer>
      </Layout>
      {/* {type === "DIGITALE_ENTGELTABRECHNUNG" && (
 
          <DigitaleEntgeltabrechnung accessToken={accessToken} monate={verknuepfung[mand]?.documents?.digiEntgelt} />

      )} */}
      {showModal && <FullPageSpinner />}
      <ResponsiveDialog
        title={"Entgeltabrechnung"}
        open={showEntgeltDetails !== ""}
        setOpen={() => setShowEntgeltDetails("")}
        actionButton={
          <Button color="primary" onClick={() => setChatWindow(false)}>
            {t("Abbrechen")}
          </Button>
        }
      >
        <EntgeltDetails payroll={showEntgeltDetails} client={client} accessToken={accessToken} program="LWEB01" />
        {/* <AI_CHAT client={client} accessToken={accessToken} program="LWEB01"  statement="AI_ASSISTANT"/> */}
      </ResponsiveDialog>

      <ResponsiveDialog
        title={"Entgeltabrechnung"}
        open={chatWindow}
        setOpen={() => setChatWindow(false)}
        actionButton={
          <Button color="primary" onClick={() => setChatWindow(false)}>
            {t("Abbrechen")}
          </Button>
        }
      >
        {/* <AI_CHAT client={client} accessToken={accessToken} program="LWEB01"  statement="AI_ASSISTANT"/> */}
      </ResponsiveDialog>
    </Page>
  );
}
export default withStyles(styles)(Payroll);
